import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface RideOrder {
  id: string;
  serviceType: 'carpool' | 'charter'; // 相乘り | 包车
  passengerId: string;
  driverId?: string;
  pickupLocation: {
    city: string;
    address: string;
    coordinates: [number, number];
  };
  dropoffLocation: {
    city: string;
    address: string;
    coordinates: [number, number];
  };
  scheduledTime: string;
  passengerCount: number;
  vehicleType?: 'business5' | 'business7'; // 包车时选择车型
  priceMultiplier?: number; // 涨价倍数
  note?: string;
  totalAmount: number;
  status: 'pending' | 'accepted' | 'picked_up' | 'completed' | 'cancelled';
  paymentStatus: 'unpaid' | 'paid' | 'refunded';
  driverInfo?: {
    name: string;
    phone: string;
    vehiclePlate: string;
    rating: number;
  };
  createdAt: string;
  updatedAt: string;
}

export interface RideFilter {
  serviceType?: 'carpool' | 'charter';
  fromCity?: string;
  toCity?: string;
  date?: string;
  passengerCount?: number;
}

interface RideState {
  orders: RideOrder[];
  currentOrder?: RideOrder;
  filter: RideFilter;
  availableRoutes: any[];
  loading: boolean;
  error?: string;
}

const initialState: RideState = {
  orders: [],
  filter: {},
  availableRoutes: [],
  loading: false,
};

const rideSlice = createSlice({
  name: 'ride',
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<RideFilter>) => {
      state.filter = { ...state.filter, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    fetchRoutesSuccess: (state, action: PayloadAction<any[]>) => {
      state.availableRoutes = action.payload;
      state.loading = false;
    },
    createRideOrderSuccess: (state, action: PayloadAction<RideOrder>) => {
      state.orders.unshift(action.payload);
      state.currentOrder = action.payload;
    },
    fetchRideOrdersSuccess: (state, action: PayloadAction<RideOrder[]>) => {
      state.orders = action.payload;
      state.loading = false;
    },
    updateRideOrderStatus: (state, action: PayloadAction<{ orderId: string; status: RideOrder['status'] }>) => {
      const order = state.orders.find(o => o.id === action.payload.orderId);
      if (order) {
        order.status = action.payload.status;
        order.updatedAt = new Date().toISOString();
      }
    },
    cancelRideOrder: (state, action: PayloadAction<string>) => {
      const order = state.orders.find(o => o.id === action.payload);
      if (order) {
        order.status = 'cancelled';
        order.updatedAt = new Date().toISOString();
      }
    },
    setCurrentOrder: (state, action: PayloadAction<RideOrder | undefined>) => {
      state.currentOrder = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setFilter,
  setLoading,
  fetchRoutesSuccess,
  createRideOrderSuccess,
  fetchRideOrdersSuccess,
  updateRideOrderStatus,
  cancelRideOrder,
  setCurrentOrder,
  setError,
} = rideSlice.actions;

export default rideSlice.reducer;